/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PackingCompleteReqVo
 */
export interface PackingCompleteReqVo {
    /**
     * 订单 id
     * @type {number}
     * @memberof PackingCompleteReqVo
     */
    orderId: number;
    /**
     * 打开包装作业时返回的商品基线版本；完成包装时必传
     * @type {string}
     * @memberof PackingCompleteReqVo
     */
    packingGoodsVersion: string;
}

/**
 * Check if a given object implements the PackingCompleteReqVo interface.
 */
export function instanceOfPackingCompleteReqVo(value: object): value is PackingCompleteReqVo {
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    if (!('packingGoodsVersion' in value) || value['packingGoodsVersion'] === undefined) return false;
    return true;
}

export function PackingCompleteReqVoFromJSON(json: any): PackingCompleteReqVo {
    return PackingCompleteReqVoFromJSONTyped(json, false);
}

export function PackingCompleteReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackingCompleteReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'],
        'packingGoodsVersion': json['packingGoodsVersion'],
    };
}

export function PackingCompleteReqVoToJSON(json: any): PackingCompleteReqVo {
    return PackingCompleteReqVoToJSONTyped(json, false);
}

export function PackingCompleteReqVoToJSONTyped(value?: PackingCompleteReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'packingGoodsVersion': value['packingGoodsVersion'],
    };
}

